import React, { useEffect, useContext, forwardRef } from 'react';
import { Layout, Menu, Button, Select, Modal, message } from 'antd';
import { CaretDownFilled , CaretUpFilled, RightCircleOutlined, LeftCircleOutlined, MenuUnfoldOutlined, CloseOutlined } from '@ant-design/icons';

import { useLocation, useHistory } from 'react-router-dom';
import './Sidebar.css';
import featherEdit from '../../Images/feather-edit.svg';
import uzioLogo from '../../Images/uzio-logo.png';
import { useState } from 'react';
import { API_URL } from '../../services/api';
import useHttp from '../../hooks/useHttp';
import { groupChatsByDate } from '../../utils/DateUtils';
import ChatEntry from './ChatHistoryEntry';
import ChatContext from '../../store/ChatContext';
import switchEmployer from '../../Images/switchEmployer.svg';
import AuthContext from '../../store/AuthContext';
import { Link } from 'react-router-dom';
import { generateUUID } from '../../utils/generateUUID';
const { Sider } = Layout;

const Sidebar = forwardRef(({ collapsed, onCollapse }, ref) => {
  const location = useLocation();
  const history = useHistory();
  const [screenSize, setScreenSize] = useState();
  const [searchClient, setSearchClient] = useState('');
  const {getRequest, putRequest} = useHttp();
  const [chatSections, setChatSections] = useState([]);
  const chatCtx = useContext(ChatContext);
  const [chatIdentifierToDelete, setChatIdentifierToDelete] = useState(null);
  const [isArchiveModalOpen, setIsArchiveModalOpen] = useState(false);
  const [chatIdentifierToArchive, setChatIdentifierToArchive] = useState(null);
  
  const [clients, setClients] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const authCtx = useContext(AuthContext);
  const onDeleteChat = (chatIdentifier) => {
    setIsDeleteModalOpen(true);
    setChatIdentifierToDelete(chatIdentifier);
  }

  const onArchiveChat = (chatIdentifier) => {
    setIsArchiveModalOpen(true);
    setChatIdentifierToArchive(chatIdentifier);
  }

  const onClientChange = (value) => {
    chatCtx.setAgentId('');
    chatCtx.onChatRefresh();
    history.push('/chat');
  }

  const handleDeleteChat = () => {
    putRequest({
      url: API_URL + '/app/ap1/agent/chat/delete?chatIdentifier=' + chatIdentifierToDelete,
      onResponse: (response) => {
        message.success('Chat deleted successfully');
        setIsDeleteModalOpen(false);
        if(chatCtx.connectionId === chatIdentifierToDelete){
          handleNewChat()
        }
        setChatIdentifierToDelete(null);
        chatCtx.onChatRefresh();
      }
    });
  }

  const handleArchiveChat = () => {
    putRequest({
      url: API_URL + '/app/ap1/agent/chat/archive?chatIdentifier=' + chatIdentifierToArchive + '&isArchive=true',
      onResponse: (response) => {
        message.success('Chat archived successfully');
        setChatIdentifierToArchive(null);
        setIsArchiveModalOpen(false);
        history.push('/chat');
        chatCtx.onChatRefresh();
      }
    });
  }

  const [collapsedWidth, setCollapsedWidth] = useState(0);

  useEffect(()=>{
      chatCtx.onChatRefresh();
  },[]);

  useEffect(()=>{
    if(chatCtx.isChatRefresh){
      setIsLoading(true);
      getRequest({
        url: API_URL + `/app/ap1/agent/chat/fetch/all`,
        onResponse: (response) => {
          setChatSections(groupChatsByDate(response));
          chatCtx.setChatSectionChatTitleList(groupChatsByDate(response));
          chatCtx.onChatRefresh();
          setIsLoading(false);
        }, 
        showLoader: false
      });
    }
  },[chatCtx.isChatRefresh]);

  useEffect(()=>{
    if(chatCtx.chatSectionChatTitleList){
      setChatSections(chatCtx.chatSectionChatTitleList);
    }
  },[chatCtx.chatSectionChatTitleList]);

  const ChatSection = ({title, chats, collapsed, location, history, onCollapse }) => (
    <>
    {chats && chats.length > 0 && <div key={title} className='mb-5'>
      {!collapsed && <div className='text-left'><h4 className="font-bold">{title}</h4></div>}
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
      >
        {chats && chats
          .map((item, index) => {
            // Ensure unique key by combining section title, chatIdentifier, and index
            const uniqueKey = `${title}-${item.chatIdentifier}-${index}`;
            return (
              <ChatEntry key={uniqueKey} item={item} collapsed={collapsed} onCollapse={onCollapse} onDeleteChat={onDeleteChat} onArchiveChat={onArchiveChat} activeKey={location.pathname} />
            );
          })}
      </Menu>
    </div>}
    </>
    
  );

  const handleSuffixClick = (e) => {
    e.stopPropagation();
    const select = e.target.closest('.ant-select');
    if (select) {
      // Find and click the actual select element to toggle dropdown
      const selectSelector = select.querySelector('.ant-select-selector');
      if (selectSelector) {
        const clickEvent = new MouseEvent('mousedown', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        selectSelector.dispatchEvent(clickEvent);
      }
    }
  };

  const handleNewChat = () => {
    // Use 'new-' prefix with UUID to create unique route each time
    const uuid = `new-${generateUUID()}`;
    history.push(`/chat/${uuid}`);
  };

  
  return (
    <>
      <Sider 
        ref={ref}
        collapsible={true}
        collapsed={collapsed}
        className="sidebar shadow-lg"
        width={220}
        collapsedWidth={collapsedWidth}
        trigger={null}
        theme="light"
      >
         {!collapsed && <div>
        
        <div className="logo flex items-center !justify-between">          
           <MenuUnfoldOutlined onClick={()=>{onCollapse(!collapsed)}} className='text-xl' />
            {/* <div className=''>
            <CloseOutlined className='text-gray-600 text-xl cursor-pointer' onClick={()=>{onCollapse(!collapsed)}} />
            </div> */}
        </div>
          </div>}

        

          {collapsed && <div className='mx-5 my-4 webPortal'>
            <div className='rounded-sm flex items-center cursor-pointer' onClick={()=>{onCollapse(!collapsed)}}>
              <img src={switchEmployer} alt="Switch Employer" className="w-6 " />
            </div>
          </div>}
       
        {!collapsed && <div className="new-chat mb-0 text-left">
          <Button 
            type="text" 
            icon={<img src={featherEdit} alt="edit" className="w-4 ml-1" />} 
            onClick={() => handleNewChat()}
            className="pl-4"
          >
            New Chat
          </Button>
        </div>}
      
        {!collapsed && <h3 className="font-bold mx-5 pb-2 border-b border-gray-400 mb-0 mt-3">Recent Chats</h3>}
        <div className="chat-section max-h-[calc(100vh-130px)] sm:max-h-[calc(100vh-180px)] overflow-y-auto">
          {isLoading ? (
            <div className="flex justify-center items-center h-32">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-white-900"></div>
            </div>
          ) : (
            chatSections.map(section => (
              <ChatSection
                key={section.title}
                title={section.title}
                chats={section.chats}
                collapsed={collapsed}
                location={location}
                history={history}
                onCollapse={onCollapse}
              />
            ))
          )}
        </div>
      </Sider>
      <Modal open={isDeleteModalOpen} onCancel={() => {setIsDeleteModalOpen(false); setChatIdentifierToDelete(null);}}
        footer={null}
        title="Delete Chat"
        width={450}
      >
        
        <p> Are you sure you want to delete this chat?</p>
        <div className='flex justify-end gap-2'>
          <Button onClick={() => {setIsDeleteModalOpen(false); setChatIdentifierToDelete(null)}}>Cancel</Button>
          <Button type='primary' danger onClick={() => {handleDeleteChat()}}>Delete</Button>
        </div>
      </Modal>

      <Modal open={isArchiveModalOpen} onCancel={() => {setIsArchiveModalOpen(false); setChatIdentifierToArchive(null);}}
        footer={null}
        title="Archive Chat"
        width={450}
      >
        <p>Are you sure you want to archive this chat?</p>
        <div className='flex justify-end gap-2'>
          <Button onClick={() => {setIsArchiveModalOpen(false); setChatIdentifierToArchive(null)}}>Cancel</Button>
          <Button type='primary' onClick={() => {handleArchiveChat()}}>Archive</Button>
        </div>
      </Modal>
    </>
  );
});

export default Sidebar; 